export function shouldSkipPayment(auth, product) {
    const isPolicyHolder = 'Policyholder' in auth.roles;
    if (isPolicyHolder) {
        return product.policyholderBind === 'WithoutPayment';
    } else {
        return product.brokerBind === 'WithoutPayment';
    }
}
